import { createAction } from 'redux-actions';

const ns = 'invoiceData/';

export const setConfirmationFlowLoading = createAction<boolean>(`${ns}SET_CONFIRMATION_FLOW_LOADING`);
export const setIsConfirmationFlowEditing = createAction<boolean>(`${ns}SET_CONFIRMATION_FLOW_EDITING`);
